module.exports = __webpack_public_path__ + "img/file-xls.c7f23272.svg";